import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestService } from '@commonServices/request.service';
import { Client as AnalyticsApi, CatalogItemViewsAttachmentViewsDto, CatalogItemViewsCountOfCatalogAvgDto, CatalogItemViewsCountsOfCatalogDto, CatalogItemViewsCountsOfCatalogPerCatalogItemDto, CatalogItemViewsOfCatalogPerDateDto, CatalogItemViewsOfCatalogPerMonthDto, CatalogItemViewsOfCatalogPerWeekDto, CatalogItemViewsTopCatalogItemsDto } from '@interfaces/HttpClient/AnalyticsApiModels';
import { firstValueFrom } from 'rxjs';
import { DaterangeService } from './daterange.service';

@Injectable()
export class CatalogDashboardCatalogItemViewsService {

	constructor(
		private analyticsApi: AnalyticsApi,
		private requestService: RequestService,
		private daterangeService: DaterangeService) { }

	async getCatalogItemViewsAttachmentViews(catalogId: number): Promise<CatalogItemViewsAttachmentViewsDto> {
		try {
			return firstValueFrom(this.analyticsApi.catalogAdminCatalogItemViews_GetCatalogItemViewsAttachmentViews(catalogId, (await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, false, [
				{ status: HttpStatusCode.NoContent, return: true }
			]);
		}
	}

	async getCatalogItemViewsPerDate(catalogId: number): Promise<CatalogItemViewsOfCatalogPerDateDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.catalogAdminCatalogItemViews_GetCatalogItemViewsCountOfCatalogPerDate(catalogId, (await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getCatalogItemViewsPerWeek(catalogId: number): Promise<CatalogItemViewsOfCatalogPerWeekDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.catalogAdminCatalogItemViews_GetCatalogItemViewsCountOfCatalogPerWeek(catalogId, (await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getCatalogItemViewsPerMonth(catalogId: number): Promise<CatalogItemViewsOfCatalogPerMonthDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.catalogAdminCatalogItemViews_GetCatalogItemViewsCountOfCatalogPerMonth(catalogId, (await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getCatalogItemViewsCountAVG(catalogId: number): Promise<CatalogItemViewsCountOfCatalogAvgDto> {
		try {
			return firstValueFrom(this.analyticsApi.catalogAdminCatalogItemViews_GetCatalogItemViewsCountAVG(catalogId, (await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getCatalogItemViewsTopCatalogItems(catalogId: number, topCount: number = 10): Promise<CatalogItemViewsTopCatalogItemsDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.catalogAdminCatalogItemViews_GetCatalogItemViewsTopCatalogItems(catalogId, (await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd, topCount));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getCatalogItemViewsCounts(catalogId: number): Promise<CatalogItemViewsCountsOfCatalogDto> {
		try {
			return firstValueFrom(this.analyticsApi.catalogAdminCatalogItemViews_GetCatalogItemViewsCounts(catalogId, (await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getCatalogItemViewsDetails(catalogId: number): Promise<CatalogItemViewsCountsOfCatalogPerCatalogItemDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.catalogAdminCatalogItemViews_GetCatalogItemViewCountOfCatalogPerCatalogItem(catalogId, (await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

}
